import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { categories } from '@/mocks/comics';

export default function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileOpen, setIsMobileOpen] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 10);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setIsMobileOpen(false);
  }, [location]);

  const handleSearch = (e: React.FormEvent) => {
    e.preventDefault();
    if (searchQuery.trim()) {
      window.REACT_APP_NAVIGATE(`/category/all?search=${encodeURIComponent(searchQuery.trim())}`);
    }
  };

  return (
    <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white shadow-sm' : 'bg-white/80 backdrop-blur-sm'}`}>
      <nav className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="flex items-center justify-between h-16">
          <Link to="/" className="flex items-center gap-2 whitespace-nowrap">
            <span className="text-xl md:text-2xl font-bold text-primary-600">哈哈漫画</span>
            <span className="hidden sm:inline text-xs text-foreground-500">韩国漫画精选</span>
          </Link>

          <div className="hidden lg:flex items-center gap-6">
            <Link to="/" className={`text-sm font-medium transition-colors ${location.pathname === '/' ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'}`}>
              首页
            </Link>
            {categories.filter(c => c.slug !== 'all').slice(0, 6).map((cat) => (
              <Link
                key={cat.slug}
                to={`/category/${cat.slug}`}
                className={`text-sm font-medium transition-colors ${location.pathname.startsWith('/category/') && location.pathname.includes(cat.slug) ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'}`}
              >
                {cat.name}
              </Link>
            ))}
            <Link to="/category/all" className="text-sm font-medium text-foreground-500 hover:text-primary-600 transition-colors">
              更多...
            </Link>
            <Link to="/about" className={`text-sm font-medium transition-colors ${location.pathname === '/about' ? 'text-primary-600' : 'text-foreground-700 hover:text-primary-600'}`}>
              关于我们
            </Link>
          </div>

          <div className="hidden lg:flex items-center gap-3">
            <form onSubmit={handleSearch} className="relative">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="w-44 px-4 py-2 text-sm rounded-full border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400 focus:ring-1 focus:ring-primary-300 transition-all"
              />
              <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400 hover:text-primary-500">
                <i className="ri-search-line"></i>
              </button>
            </form>
          </div>

          <button
            onClick={() => setIsMobileOpen(!isMobileOpen)}
            className="lg:hidden flex items-center justify-center w-10 h-10 rounded-lg hover:bg-background-100 transition-colors"
            aria-label="菜单"
          >
            <i className={`text-xl ${isMobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </nav>

      {isMobileOpen && (
        <div className="lg:hidden bg-white border-t border-foreground-100 shadow-lg">
          <div className="px-4 py-4 space-y-1">
            <Link to="/" className="block px-3 py-2 text-sm font-medium rounded-lg hover:bg-background-100">首页</Link>
            {categories.filter(c => c.slug !== 'all').map((cat) => (
              <Link key={cat.slug} to={`/category/${cat.slug}`} className="block px-3 py-2 text-sm font-medium rounded-lg hover:bg-background-100">
                {cat.name}
              </Link>
            ))}
            <Link to="/about" className="block px-3 py-2 text-sm font-medium rounded-lg hover:bg-background-100">关于我们</Link>
            <form onSubmit={handleSearch} className="relative mt-3">
              <input
                type="text"
                value={searchQuery}
                onChange={(e) => setSearchQuery(e.target.value)}
                placeholder="搜索漫画..."
                className="w-full px-4 py-2.5 text-sm rounded-full border border-foreground-200 bg-background-50 focus:outline-none focus:border-primary-400"
              />
              <button type="submit" className="absolute right-3 top-1/2 -translate-y-1/2 text-foreground-400">
                <i className="ri-search-line"></i>
              </button>
            </form>
          </div>
        </div>
      )}
    </header>
  );
}